module.exports = __webpack_public_path__ + "img/pro_six_7.d8d00c81.jpg";